import { useOrganization } from '@/hooks/useOrganization';
import {
  type AppCapability,
  type Capabilities,
} from '@/lib/capabilities';

interface UseCapabilitiesResult {
  capabilities: Capabilities;
  hasCapability: (capability: AppCapability) => boolean;
  isLoading: boolean;
}

export function useCapabilities(): UseCapabilitiesResult {
  const { capabilities, hasCapability, isLoading } = useOrganization();

  return {
    capabilities,
    hasCapability: (capability: AppCapability) => hasCapability(capability),
    isLoading,
  };
}
